import { Typography } from "@mui/material";
import ACROSS_LOGO from "@assets/logo/AcrossLogo.png";
import { VERSION } from "@constants/index";
import "./index.scss";

const LoginFooter = () => {
  return (
    <div className="login-footer">
      <img src={ACROSS_LOGO} alt="OneAssist Logo" className="footer-logo" />

      <Typography variant="caption" className="footer-text">
        Copyright © 2025. All Rights Reserved
      </Typography>

      <Typography variant="caption" className="footer-version">
        {VERSION}
      </Typography>
    </div>
  );
};

export default LoginFooter;
